var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ccanvas class=\"chart chart-line\" chart-data=\"$ctrl.data\" chart-labels=\"$ctrl.labels\"\u003E\u003C\u002Fcanvas\u003E";;return pug_html;};
module.exports = template;